<template>
  <div class="max-diff">
    <div>
      <template v-if="isPKDiff">
        <van-radio-group :value="currentResult.bestId" checked-color="var(--theme-color)">
          <div class="max-diff-pk  clearfix">
            <div class="max-diff-pk-left choice-item-wrap"  :class="{ selected: currentResult.bestId === currentRenderTask[0].id }">
              <single-choice-item
                :item="currentRenderTask[0]"
                :value="currentResult.bestId"
                @click="onSelectBest(currentRenderTask[0])"
              />
            </div>
            <div class="max-diff-pc-icon">
              <span>PK</span>
            </div>
            <div class="max-diff-pk-right choice-item-wrap"  :class="{ selected: currentResult.bestId === currentRenderTask[1].id }">
              <single-choice-item
                :item="currentRenderTask[1]"
                :value="currentResult.bestId"
                @click="onSelectBest(currentRenderTask[1])"
              />
            </div>
          </div>
        </van-radio-group>
      </template>
      <template v-else>
        <transition tag="div" name="max-diff">
        <table class="max-diff-table" :key="currentNum">
          <colgroup>
            <col style="width:33.33%" span="3" />
          </colgroup>
          <thead>
          <tr>
            <th v-if="issue.align === 0"></th>
            <th>{{ issue.labelBest }}</th>
            <th v-if="issue.align === 1"></th>
            <th>{{ issue.labelWorst }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in currentRenderTask" :key="item.id">
            <td v-if="issue.align === 0">
              <div v-html="item.content.richText"></div>
            </td>
            <td>
              <van-radio-group :value="currentResult.bestId" @input="onChangeBest(item.id,item)">
                <van-radio class="justify-center" :name="item.id">
                  <template v-slot:icon="{ checked }">
                    <icon-radio :value="checked" />
                  </template>
                </van-radio>
              </van-radio-group>
            </td>
            <td v-if="issue.align === 1">
              <div v-html="item.content.richText"></div>
            </td>
            <td>
              <van-radio-group :value="currentResult.worstId" @input="onChangeWorst(item.id,item)">
                <van-radio class="justify-center" :name="item.id">
                  <template v-slot:icon="{ checked }">
                    <icon-radio :value="checked" />
                  </template>
                </van-radio>
              </van-radio-group>
            </td>
          </tr>
          </tbody>
        </table>
        </transition>
      </template>
      <div class="max-diff-progress text-center">
        <div class="max-diff-reset-btn" v-if="!view">
          <span class="text-theme" @click="onResetSelect">重新选择</span>
        </div>
        <div class="flex items-center w-full justify-center">
          <van-button
              v-if="view"
              :disabled="disabledLeftBtn"
              @click="onDecrease"
              icon="arrow-left"
              type="primary"
              plain
              size="mini"
          />
          <div  class="max-diff-progress-text">
            <span>{{ currentNum }}</span>
            <span>/</span>
            <span>{{ issue.taskNum }}</span>
          </div>
          <van-button
              v-if="view"
              :disabled="disabledRightBtn"
              @click="onIncrease"
              icon="arrow"
              type="primary"
              plain
              size="mini"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import IconRadio from '../../components/base/IconRadio'
import SingleChoiceItem from '../components/SingleChoiceItem'

export default {
  name: 'MaxDiff',
  components: { SingleChoiceItem, IconRadio },
  changeExpr: 'changeExpr',
  data() {
    return {
      currentNum: 1
    }
  },
  computed: {
    disabledLeftBtn() {
      return this.currentNum <= 1
    },
    disabledRightBtn() {
      return this.currentNum >= this.issue.taskNum
    },
    changeExpr() {
      return this.issue.results.map(item => item.bestId + '-' + item.worstId).join(',')
    },
    currentRenderTask() {
      return this.issue.tasks[this.currentNum - 1]
    },
    currentResult() {
      return this.issue.results[this.currentNum - 1]
    },
    isPKDiff() {
      return false// this.issue.numPerTask === 2
    }
  },
  methods: {
    onDecrease() {
      this.currentNum--
    },
    onIncrease() {
      this.currentNum++
    },
    onChangeBest(val, item) {
      if (this.currentResult.worstId === val) {
        this.currentResult.worstId = ''
      }
      this.currentResult.bestId = val
      this.checkAndNext()
    },
    onChangeWorst(val, item) {
      if (this.currentResult.bestId === val) {
        this.currentResult.bestId = ''
      }
      this.currentResult.worstId = val
      this.checkAndNext()
    },
    checkAndNext() {
      if (this.changeAndNextTimer) {
        clearTimeout(this.changeAndNextTimer)
      }
      if (this.currentNum === this.issue.tasks.length) return
      if (this.issue.numPerTask === 1) {
        this.changeAndNextTimer = setTimeout(() => {
          this.currentNum++
          this.changeAndNextTimer = null
        }, 500)
        return
      }

      if (this.currentResult.bestId && this.currentResult.worstId) {
        this.changeAndNextTimer = setTimeout(() => {
          this.currentNum++
          this.changeAndNextTimer = null
        }, 500)
      }
    },
    onResetSelect() {
      this.issue.results.forEach(item => {
        item.bestId = ''
        item.worstId = ''
      })
      this.currentNum = 1
    },
    onSelectBest(item) {
      this.currentResult.bestId = item.id
      let a = this.currentRenderTask.find(t => t.id !== item.id)
      this.currentResult.worstId = a.id
      this.checkAndNext()
    }
  },
  mounted() {
    this.$nextTick(() => {
      let idx = this.issue.getCurrentIndex()
      if (idx !== -1) {
        this.currentNum = idx + 1
      }
    })
  }

}
</script>

<style scoped lang="scss">
.max-diff {
  .max-diff-table {
    border: 1px solid;
    @apply border-border-gray;
  }

  .max-diff-table {
    text-align: center;
    width: 100%;

    th {
      font-weight: normal;
    }

    td, th {
      padding: 6px 0;
      @apply border border-border-gray border-solid;
    }

    thead {
      tr {
        @apply bg-bg-common-color;
      }
    }

    tbody {
      tr {
        //&:nth-child(2n) {
        //  @apply bg-bg-common-color;
        //}
      }
    }
  }

  .max-diff-progress {
    margin-top: 8px;
    position: relative;
  }

  .max-diff-reset-btn {
    position: absolute;
    left: 0;
    top: 0;
  }

  .max-diff-progress-text {
    display: inline-block;
    padding: 0 16px;
    line-height: 22px;
    border-radius: 12px;
    color: rgba(0, 0, 0, .45);
    @apply bg-card-bg-gray;
  }

  .max-diff-pk {

    .max-diff-pk-left, .max-diff-pk-right {
      width: calc(50% - 20px);
      float: left;
      box-sizing: border-box;
    }

    .max-diff-pc-icon {
      padding: 6px 0;
      float: left;
      margin: 0 6px;

      span {
        display: block;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: rgba(232, 163, 27, .15);
        text-align: center;
        line-height: 28px;
        font-size: 12px;
        color: #E8A31B;
        font-weight: 700;
        font-family: Arial-BoldMT;
      }
    }
  }

  .max-diff-enter-active {
    transition: all .8s ease;
  }

  .max-diff-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    display: none;
  }

  .max-diff-enter, .max-diff-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

}
</style>